import { ValidationErrors } from "@angular/forms";
import * as moment from "moment-timezone";

export const ZONA_FECHA_EMISION = "America/Santiago";

export function rangoFechaEmision(ahora = moment.tz(ZONA_FECHA_EMISION)) {
	const base = ahora.clone().tz(ZONA_FECHA_EMISION);
	return {
		min: base.clone().subtract(1, "month").startOf("month"),
		max: base.clone().add(1, "month").endOf("month"),
	};
}

/** El calendario entrega días locales; los Date persistidos representan instantes. */
export function parseFechaEmision(value: any): moment.Moment {
	const fecha = value && Object.prototype.hasOwnProperty.call(value, "startDate") ? value.startDate : value;
	if (moment.isMoment(fecha)) {
		return moment.tz(fecha.format("YYYY-MM-DD"), "YYYY-MM-DD", true, ZONA_FECHA_EMISION);
	}
	if (fecha instanceof Date) {
		return moment.tz(fecha, ZONA_FECHA_EMISION).startOf("day");
	}
	return typeof fecha === "string"
		? moment.tz(fecha, "DD/MM/YYYY", true, ZONA_FECHA_EMISION)
		: moment.invalid();
}

export function validarFechaEmision(value: any, rango = rangoFechaEmision()): ValidationErrors | null {
	const fecha = value && Object.prototype.hasOwnProperty.call(value, "startDate") ? value.startDate : value;
	if (fecha == null || fecha === "") return { required: true };
	const parsed = parseFechaEmision(value);
	if (!parsed.isValid()) return { fechaInvalida: true };
	return parsed.isBetween(rango.min, rango.max, "day", "[]") ? null : { fechaFueraDeRango: true };
}
